import resolveConfig from "tailwindcss/resolveConfig";
import tailwind from "../../../tailwind.config";

const fullConfig = resolveConfig(tailwind);

export const clusterIcon = `
<svg
aria-hidden="true"
focusable="false"
data-prefix="fas"
data-icon="map-marker-alt"
class="svg-inline--fa fa-map-marker-alt fa-w-12"
role="img"
xmlns="http://www.w3.org/2000/svg"
viewBox="0 0 240 240"
fill="${fullConfig.theme.colors.secondary.default}"
>
    <circle cx="120" cy="120" opacity=".8" r="120" />
</svg>
`;
